/* eslint-disable max-len */
import jsonata from 'jsonata';
import { IPedigreeGraphNode, IPedigreeMapperLink } from './PedigreeService';

export default class PedigreeMapper {
  private configuration!: string;

  private bindings = {
    marker_list: [
      'ER',
      'CK14',
      'CK5.6',
      'PR',
      'HER2',
    ],
    disease_maps: {
      breast: {
        ICD10: 'C50',
        title: 'Breast Cancer',
      },
      ovarian: {
        ICD10: 'C56',
        title: 'Ovarian Cancer',
      },
      pancreatic: {
        ICD10: 'C25',
        title: 'Pancreatic Cancer',
      },
      colorectal: {
        ICD10: 'C18',
        title: 'Colorectal Cancer',
      },
      prostate: {
        ICD10: 'C61',
        title: 'Prostate Cancer',
      },
      melanoma: {
        ICD10: 'C43',
        title: 'Melanoma',
      },
      lung: {
        ICD10: 'C34',
        title: 'Lung Cancer',
      },
      liver: {
        ICD10: 'C22',
        title: 'Liver Cancer',
      },
      kidney: {
        ICD10: 'C64',
        title: 'Kidney Cancer',
      },
      bladder: {
        ICD10: 'C67',
        title: 'Bladder Cancer',
      },
      nonHodgkins: {
        ICD10: 'C85',
        title: 'Non-Hodgkins Lymphoma',
      },
      leukemia: {
        ICD10: 'C95',
        title: 'Leukemia',
      },
      thyroid: {
        ICD10: 'C73',
        title: 'Thyroid Cancer',
      },
      uterine: {
        ICD10: 'C53',
        title: 'Uterine Cancer',
      },
    },
    gene_list: [
      'BRCA1',
      'BRCA2',
    ],
  };

  public configure(configuration: string) {
    this.configuration = configuration;
  }

  /**
   * Generic Mapper entry point
   *
   * @param state
   */
  public async getMapped(state: any): Promise<({ path: string, links?: IPedigreeMapperLink[] } & IPedigreeGraphNode)[]> {
    // TODO: BRCA Pedigree mapping drop an incorrect path in specific cases (e.g. Family Health sections was present
    //  and then removed)
    return (await jsonata(this.configuration).evaluate(state?.data || {}, this.bindings)).filter((entry: any) => entry.path !== '[position()=1]');
  }
}
